import type {
  ApiResponse,
  CreateTodoRequest,
  HealthResponse,
  PaginatedResponse,
  Todo,
  UpdateTodoRequest,
} from "@repo/example-shared";

const API_BASE = import.meta.env.VITE_API_URL ?? "";

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (response.status === 204) {
    // SAFETY: a 204 has no body; callers that expect one pass T = void.
    return undefined as T;
  }
  // SAFETY: our own endpoint, served from this repo; T names the shape the handler returns.
  return response.json() as Promise<T>;
}

export async function getHealth(): Promise<ApiResponse<HealthResponse>> {
  return fetchJson(`${API_BASE}/api/health`);
}

export async function getTodos(): Promise<
  ApiResponse<PaginatedResponse<Todo>>
> {
  return fetchJson(`${API_BASE}/api/todos`);
}

export async function createTodo(
  data: CreateTodoRequest,
): Promise<ApiResponse<Todo>> {
  return fetchJson(`${API_BASE}/api/todos`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function updateTodo(
  id: string,
  data: UpdateTodoRequest,
): Promise<ApiResponse<Todo>> {
  return fetchJson(`${API_BASE}/api/todos/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function deleteTodo(id: string): Promise<void> {
  await fetch(`${API_BASE}/api/todos/${id}`, { method: "DELETE" });
}
